import axios from 'axios'

export default {
  getClientForm () {
    return axios.get('/ilaw/api/form-fields/queryFormField')
  },
  /**
   * 返回部门树
   * @return {Promise<AxiosResponse<T>>}
   */
  getDepartment () {
    return axios.get('/permission/api/v1/permission/department/allDepartment')
  },
  /**
   * 返回部门列表
   * @return {Promise<AxiosResponse<T>>}
   */
  getDepartmentList () {
    return axios.get('/permission/api/v1/permission/department/allDepartmentList')
  },
  /**
   * 获取自定义表单列表
   * @return {Promise<AxiosResponse<T>>}
   */
  getFormFields () {
    return axios.get('/contact/api/v1/formFields/list')
  },
  //  查询自定义表单表头信息
  getCustomerHead (params) {
    return axios.get(`/contact/api/v1/customHead?bizEnum=${params.bizEnum}&formId=${params.formId}`)
  },
  resetCustomerHead (params) {
    return axios.get(`/contact/api/v1/customHead/reset?bizEnum=${params.bizEnum}&formId=${params.formId}`)
  },
  // 查询自定义表单表头筛选项
  getCustomerHeadProps (params) {
    return axios.get(`/contact/api/v1/customHead/${params.contactType}?fieldIds=${params.fieldIds}`)
  },
  // 保存自定义表单表头排序信息
  saveCustomerHead ({ bizEnum, formId, customHeadConfigsDTOS }) {
    return axios.post(`/contact/api/v1/customHead?bizEnum=${bizEnum}&formId=${formId}`, { customHeadConfigsDTOS })
  },
  // 删除客户
  delCustomer (params) {
    return axios.delete(`/contact/api/v1/contact/${params.customerId}`)
  },
  /**
   * 获取表单配置
   * @param formId
   * @return {Promise<AxiosResponse<T>>}
   */
  getFormFieldConfiguration (formId) {
    return axios.get(`/contact/api/v1/formFields/${formId}`)
  },
  /**
   * 更新表单配置
   * @param bizEnum  表单类型
   * @param dtos     表单配置信息
   * @param formId   表单ID
   * @param formName 表单名
   * @return {Promise<AxiosResponse<T>>}
   */
  updateFormFields ({ bizEnum, dtos, formId, formName }) {
    return axios.post('/contact/api/v1/formFields', { bizEnum, dtos, formId, formName })
  },
  // 查询自定义表单列表
  getFormFieldsList () {
    return axios.get(`/contact/api/v1/formFields/list`)
  },
  /**
   * 获取客户中团队成员
   * @param id
   * @return {Promise<AxiosResponse<T>>}
   */
  getMembersByClientId (id) {
    return axios.get(`/contact/api/v2/alpha/contact/detail/${id}`)
  },
  /**
   * 获取基本信息
   * @param id
   * @return {Promise<AxiosResponse<T>>}
   */
  getContactInfo (id) {
    return axios.get(`/contact/api/v2/alpha/contact/info/${id}`)
  },
  /**
   * 获取客户成员角色信息
   * @return {Promise<AxiosResponse<T>>}
   */
  getRoles () {
    return axios.get('/permission/api/v1/permission/roles?subjecttype=CON')
  },
  /**
   * 更改客户成员角色
   * @param clientId  客户id
   * @param userId    用户id
   * @param roleId    角色id
   * @return {Promise<AxiosResponse<T>>}
   */
  updateMemberRole (clientId, { userId, roleId }) {
    return axios.put(`/contact/api/v2/alpha/contact/updatemember/${clientId}`, { userId, roleId })
  },
  /**
   * 删除客户下某个成员
   * @param clientId
   * @param userId
   * @return {Promise<AxiosResponse<T>>}
   */
  deleteClientMember ({ clientId, userId }) {
    return axios.delete(`/contact/api/v2/alpha/contact/deletemember/${clientId}?userId=${userId}`)
  },
  /**
   * 获取在职用户
   * @return {Promise<AxiosResponse<T>>}
   */
  getUsers () {
    return axios.get('/im/v1/users')
  },
  /**
   * 获取全部用户
   * @return {Promise<AxiosResponse<T>>}
   */
  getAllUsers () {
    return axios.post('/user/api/v1/auth/search/lawyer', {
      'startPage': 1,
      'pageSize': 9999,
      'type': -1,
      'name': '',
      'order': null,
      'isAsc': 'N',
      'queryExpandUserInfoParamVO': {
        'associateMember': {},
        'associateDepartment': {},
        'selectBox': {},
        'inputSelect': {},
        'timeSelect': {}
      },
      'itemOrAnd': false
    })
  },
  /**
   * 添加负责人
   * @param clientId
   * @param roleId
   * @param userId
   * @return {Promise<AxiosResponse<T>>}
   */
  addMember ({ clientId, roleId, userId }) {
    return axios.put(`/contact/api/v2/alpha/contact/addmember/${clientId}`, { roleId, userId })
  },
  /**
   * 根据部门添加客户中的成员
   * @param clientId
   * @param roleId
   * @param departId
   * @return {Promise<AxiosResponse<T>>}
   */
  addMemberByDepartment ({ clientId, roleId, departId }) {
    return axios.post(`/ilaw/api/v2/contact/depart/${clientId}?roleId=${roleId}&departId=${departId}`)
  },
  updateOwner ({ bizEnum, formFieldDetailMap, customerId }) {
    return axios.put(`/contact/api/v1/contact/owner/${customerId}`, { bizEnum, formFieldDetailMap })
  },
  /**
   * 获取客户相关项目的数目(复用原有接口，其实返回了项目详情)
   * @param clientId
   * @param page
   * @param pageSize
   * @return {Promise<AxiosResponse<T>>}
   */
  getClientMatterCount ({ clientId, page = 1, pageSize = 20 }) {
    return axios.get(`/matterserver/api/v2/matters/clientMatter?clientId=${clientId}&page=${page}&pageSize=${pageSize}`)
  },
  // 根据自定义表单id查询自定义表单详情
  getFormFieldDetail () {
    return axios.get(`/contact/api/v1/formFields/category`)
  },
  // 保存客户
  saveCustomer (data) {
    return axios.post('/contact/api/v1/contact', data)
  },
  // 修改客户信息
  changeCustomer ({ bizEnum, formFieldDetailMap, formId, customerId, contactIndustry, formFieldDateRemindMap }) {
    return axios.put(`/contact/api/v1/contact/${customerId}`, { bizEnum, formFieldDetailMap, formId, contactIndustry, formFieldDateRemindMap })
  },
  getDateRemindInfoByCustomerId(customerId) {
    return axios.get(`/contact/api/v1/contact/getFormAllFieldDateRemindInfo/${customerId}`)
  },
  /**
   * 获取指定模块下的所有权限
   * @param userId    当前登录用户的id
   * @param type      模块类型
   * @param clientId  客户id
   * @return {Promise<AxiosResponse<T>>}
   */
  queryPermissionByModule ({ userId, type, clientId }) {
    const url = `/permission/api/v1/permission/engine/${userId}/getPmsStrings?subjectid=${clientId}&type=${type}`
    return axios.get(url)
  },

  /**
   * 由传入的权限字符串转换成指定对象中的权限参数
   * str 接受的后台返回的权限字符串
   * target 转换后的权限参数存储的对象，一般指定controller中的$scope.data.rights
   */
  rightsNameSwitch (str, target) {
    const rightName = str.split('.')
    let result = ''
    for (let i = 0; i < rightName.length; i++) {
      result += rightName[i].replace(':', function () {
        return ''
      })
    }
    target[result] = true
  },
  getFormList (data) {
    return axios.post(`/contact/api/v2/contact/list`, data)
  },
  /**
   * 获取客户详情---编辑用到
   * @param clientId
   * @return {Promise<AxiosResponse<T>>}
   */
  getClientDetailToEdit (clientId) {
    return axios.get(`/contact/api/v1/contact/${clientId}`)
  },
  /**
   * 获取客户详情---查看详情用到
   * @param clientId
   * @return {Promise<AxiosResponse<T>>}
   */
  getClientDetail (clientId) {
    return axios.get(`/contact/api/v1/contact/detail/${clientId}`)
  },
  watchCustomer (customerId) {
    return axios.put(`/contact/api/v2/alpha/contact/addStar/${customerId}`)
  },
  cancelWatchCustomer (customerId) {
    return axios.delete(`/contact/api/v2/alpha/contact/deleteStar/${customerId}`)
  },
  /**
   * 获取司法平台配置
   * @param judicialMatterTypeId
   * @param moduleType
   * @param processCode
   * @return {Promise<AxiosResponse<T>>}
   */
  getJudicialConfiguration ({ judicialMatterTypeId, moduleType, processCode }) {
    return axios.get(`/matterserver/api/v2/judicial/extra/field?judicialMatterTypeId=${judicialMatterTypeId}&moduleType=${moduleType}&processCode=${processCode}`)
  },
  /**
   * 获取客户关联的客户
   * @param clientId
   * @return {Promise<AxiosResponse<T>>}
   */
  getRelatedClient (clientId) {
    return axios.get(`/contact/api/v2/alpha/contact/relatedperson/${clientId}`)
  },
  /**
   * 更新某个客户关系
   * @param params
   * @return {Promise<AxiosResponse<T>>}
   */
  updateRelationship (params) {
    return axios.put(`/contact/api/v2/alpha/contact/item`, params)
  },
  /**
   * 获取已有客户
   * @param name
   * @return {Promise<AxiosResponse<T>>}
   */
  getCustomers (name) {
    return axios.get(`/contact/api/v2/alpha/contact/list?name=${name}`)
  },
  /**
   * 关联客户
   * @param params
   * @return {Promise<AxiosResponse<T>>}
   */
  updateRelation (params) {
    return axios.post(`/contact/api/v2/alpha/contact/relation`, params)
  },
  /**
   * 删除某个关联客户
   * @param id
   * @return {Promise<AxiosResponse<T>>}
   */
  removeRelation (id) {
    return axios.delete(`/contact/api/v2/alpha/contact/item/${id}`)
  },
  /**
   * 当前登录者是否有超管或系管权限
   * @return {Promise<AxiosResponse<T>>}
   */
  verifyUser () {
    return axios.get(`/permission/api/v1/permission/admin/getAdminUser`)
  },
  /**
   * 查询机构信息
   * @param keyWord
   * @return {Promise<AxiosResponse<T>>}
   */
  searchCompany (keyWord = '') {
    return axios.get(`/enterprise/api/v1/enterprise/search?pageNum=1&thirdQueryId=${keyWord}`)
  },
  bindThitrdId (params) {
    return axios.put(`/enterprise/api/v1/enterprise/bindthirdid`, params)
  },
  baseInfo (id) {
    return axios.get(`/enterprise/api/v1/enterprise/baseinfo?eid=${id}&skipCache=true`)
  },
  /**
   * 是否有权限
   * @return {Promise<AxiosResponse<T>>}
   */
  queryRight (permissionString) {
    return axios.get(`/permission/api/v1/permission/auth/hasRight?permissionString=${permissionString}`)
  },
  /**
   * 是否有权限
   * @return {Promise<AxiosResponse<T>>}
   */
  queryRights (permissionString) {
    return axios.get(`/permission/api/v1/permission/auth/hasRights?permissionStrings=${permissionString}`)
  },
  /**
   * 添加客户记录
   */
  addFollowRecord (params) {
    return axios.post(`/contact/api/v1/record/followRecord`, params)
  },
  /**
   * 删除客户记录
   */
  deleteFollowRecord (followRecordId, customerId) {
    return axios.delete(`/contact/api/v1/record/followRecord/${followRecordId}?customerId=${customerId}`)
  },
  /**
   * 获取客户的跟随记录
   */
  getFollowRecord (customerId) {
    return axios.get(`/contact/api/v1/record/followRecord/${customerId}`, {})
  },
  /**
   * 获取操作记录
   */
  getOperateList (customerId) {
    return axios.get(`/contact/api/v1/record/operateRecord/${customerId}`, {})
  },
  /**
   * 获取下载地址
   */
  getDownloadUrl (fileId) {
    return axios.get(`/contact/api/v1/file/download?fileId=${fileId}`, {})
  },
  /**
   * 获取预览地址
   */
  getPreviewUrl (fileId) {
    return axios.get(`/contact/api/v1/file/preview?fileId=${fileId}`, {})
  },
  /**
   * 客户重名检测
   * @param customerName
   * @return {Promise<AxiosResponse<T>>}
   */
  checkNamesake (customerName) {
    return axios.post('/contact/api/v1/contact/namesake', { customerName })
  },
  /**
   * 更新客户印象
   * @param params
   * @return {Promise<AxiosResponse<T>>}
   */
  updateImpression (params) {
    return axios.put('/contact/api/v1/contact/impression', params)
  },
  /**
   * 获取司法平台是否开启状态
   */
  getOpenState () {
    return axios.get('/matterserver/api/v2/judicial/lawOffice/info', {})
  },
  // 获取项目类型
  getMatterType (params) {
    return axios.get(`/matterserver/api/v2/matterType/parentType/matterType/list?parentTypes=${params.parentTypes}&state=${params.state}`)
  },
  // 查询平台版项目模板的权限
  getRightByModuleStringName (params) {
    return axios.post(`/common/api/v1/configs/modules/rights/moduleNames`, params)
  },

  // 查询团队版项目模板的权限
  queryRightByPermission (permissionStrings, id) {
    let url, permission, params
    if (!id) {
      url = '/permission/api/v1/permission/auth/hasRights'
      permission = {}
      params = {
        permissionStrings: permissionStrings
      }
    } else {
      url = '/permission/api/v1/permission/engine/' + localStorage.userid + '/isHasRightMatOrConByPmsString'
      permission = {}
      params = {
        pmsstring: permissionStrings + ':' + id
      }
    }

    return axios({
      method: 'get',
      url,
      params
    }).then(datas => {
      // 装换成key,value形式的值返回
      datas.data.map(function (data) {
        permission[data.permissionString] = data.hasRight
      })
      return permission
    })
  },
  getMatterList (params) {
    return axios.get(`/matterserver/api/v2/matters/clientMatter`, { params: params })
  },

  getAllMatterids (customerId) {
    return axios.get(`/contact/api/v2/alpha/contact/matterIds/${customerId}`)
  },
  // 客户列表回去客户类型
  getClientType() {
    return axios.get('/contact/api/v2/contact/getLeftTab')
  },
  // 客户列表筛选获取下拉选项
  getClientListFilterOptions(bizEnum) {
    return axios.get('/contact/api/v2/contact/getProps?bizEnum=' + bizEnum)
  },
  // 导出客户列表
  exportClientList(data) {
    return axios.post(`/contact/api/v2/contact/exportContact`, data, {
      responseType: 'blob'
    })
  },
  // 客户成员数据
  getDeptWithUserList() {
    return axios.get('/contact/api/v2/contact/getTreeAllSubDepartmentAndUser')
  },
  // 检测重复客户名称
  checkNameRepeat(name) {
    return axios.get('/contact/api/v2/alpha/contact/getFirmContacts?accuratename=' + name)
  },
  // 保存客户成员
  saveRoleMembers(id, params) {
    return axios.post(`/contact/api/v2/contact/${id}/saveRoleMembers`, params)
  },
  // 获取客户表单类型
  getClientFormType() {
    return axios.get(`/contact/api/v1/formFields/list`)
  },

  // 联系人tab相关
  // 获取客户联系人列表
  getClientRelationList(customerId) {
    return axios.get(`/contact/api/v1/liaison/customerLiaison?customerId=${customerId}`)
  },
  // 获取项目联系人列表
  getMatterRelationList(customerId) {
    return axios.get(`/contact/api/v1/liaison/matterLiaison?customerId=${customerId}`)
  },
  // 确定添加联系人
  confirmAddRelation(data) {
    return axios.post(`/contact/api/v1/liaison/create`, data)
  },
  // 获取编辑联系人列表
  getEditRelationList(params) {
    return axios.get('/contact/api/v1/liaison/relationList', { params })
  },
  // 确定编辑联系人
  confirmEditRelation(data) {
    return axios.post(`/contact/api/v1/liaison/relation`, data)
  },
  // 异步校验手机号、身份证号重复
  asyncValidate(type, string, exceptId) {
    return axios.get('/contact/api/v1/liaison/checkCreate', {
      params: {
        type,
        checkInfo: string,
        exceptId: exceptId || null
      }
    })
  }
}
